module.exports = __webpack_public_path__ + "img/aiIcon-animalDetect.5c33ed18.svg";